export const LOADING = "LOADING";
export const LOADED = "LOADED";